import React from 'react';
import {
  DateTimeFilter,
  ProviderDetails,
  ProviderSummary,
} from '../../../../../../api/models';
import { SimilarProviders } from '../../similarProviders';
import { FormDialog } from '../../../../../../core/components/dialogs/formDialog';

export interface SimilarProvidersDialogProps {
  isOpen: boolean;
  alternateProviders: ProviderSummary[];
  filter: DateTimeFilter;
  onCareProviderSelected: (newProviderDetails: ProviderDetails) => void;
  onClose: () => void;
}

const SimilarProvidersDialog: React.FC<SimilarProvidersDialogProps> = (
  props: SimilarProvidersDialogProps
) => {
  return (
    <FormDialog
      title="Similar care providers"
      isOpen={props.isOpen}
      onDismiss={props.onClose}
    >
      <SimilarProviders
        filter={props.filter}
        alternateProviders={props.alternateProviders}
        onCareProviderSelected={props.onCareProviderSelected}
      />
    </FormDialog>
  );
};

export default SimilarProvidersDialog;
